import React, { useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import { QrReader } from "react-qr-reader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode, faTimes } from "@fortawesome/free-solid-svg-icons";

import * as api from "../../../api";

import "./LoginByQrForm.sass";

// Accept either a raw UUID or a URL that contains the UUID in its path/query.
const QR_TOKEN_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

function extractQrToken(rawValue) {
  if (!rawValue) return null;
  const match = rawValue.match(QR_TOKEN_REGEX);
  return match ? match[0] : null;
}

export default function LoginByQrForm({ onSuccess = () => {} }) {
  const [showCameraPopup, setShowCameraPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});

  const handleQrToken = (qrToken) => {
    setIsSubmitting(true);
    setBackendErrors({});

    api.auth
      .loginByQr(qrToken)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          setBackendErrors(error.response.data);
        } else if (error.response && error.response.status === 403) {
          setBackendErrors({
            nonFieldErrors: [
              error.response.data?.detail ||
                "You are not authorized to make that request",
            ],
          });
        } else {
          setBackendErrors({ nonFieldErrors: ["Something went wrong"] });
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleScanResult = (result, error) => {
    if (!result) return;
    const qrToken = extractQrToken(result?.text);
    if (!qrToken) {
      setBackendErrors({ nonFieldErrors: ["Invalid QR code"] });
      return;
    }
    setShowCameraPopup(false);
    handleQrToken(qrToken);
  };

  return (
    <Row className="LoginByQrForm">
      <Col xs={12}>
        <Row>
          <Col xs={12}>
            {backendErrors?.nonFieldErrors?.map((error) => (
              <span key={`nonFieldErrors-${error}`} className="d-block error">
                {error}
              </span>
            ))}
            {backendErrors?.qr_token?.map((error) => (
              <span key={`qrToken-${error}`} className="d-block error">
                {error}
              </span>
            ))}
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={{ span: 6, offset: 6 }}>
            <Button
              variant="primary"
              className="form-control"
              disabled={isSubmitting}
              onClick={() => setShowCameraPopup(true)}
            >
              <FontAwesomeIcon icon={faQrcode} className="mr-2" />
              {isSubmitting ? "Logging in..." : "Login with QR"}
            </Button>
          </Col>
        </Row>

        {showCameraPopup && (
          <div className="camera-popup">
            <FontAwesomeIcon
              icon={faTimes}
              className="qr-code-close-icon"
              size="2x"
              onClick={() => setShowCameraPopup(false)}
            />
            <QrReader
              onResult={handleScanResult}
              constraints={{ facingMode: "environment" }}
              containerStyle={{ width: "100%", height: "100%", zIndex: "1" }}
              videoStyle={{
                width: "100%",
                height: "100%",
                zIndex: "1",
                position: "fixed",
              }}
            />
          </div>
        )}
      </Col>
    </Row>
  );
}
